import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
const ViewMilestoneSubmission=()=> {
   return (
    <React.Fragment>
          <Container fluid>
                    {/* BreadCrumb area starts */}
                    <div className="mainPageHeader d-flex justify-content-between">
                        <BreadCrumb title="View Page" />
                    </div>
                </Container>
    </React.Fragment>
  );
}
export default ViewMilestoneSubmission;